
<collapsible-section
  class="collapse-item"
  :id="`objectModelUsersCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
  control-name="objectModelUsersCollapse"
  :is-open="false"
>
  <template #section-header>
    <row>
      <column>
        Users
      </column>
    </row>
  </template>
  <template #section-contents>
    <template v-for="section in handler.userDataSections(lowerQ)">
      <field-item
        v-for="field in section.fields"
        :key="field.id"
        :disabled="handler.isDisabled(field, parentTreeContext)"
        @click="select(section.select(field, section.type))"
      >
        <row>
          <prefix>
            <icon glyph="member" />
          </prefix>
          <column>
            {{field.label}}
          </column>
        </row>
      </field-item>
    </template>
  </template>
</collapsible-section>
